import React, { Component } from "react";
import Layout from "../../../Layout/layout";
import Helmet from "react-helmet";
import "../../../styles/reports/reports.scss";
import {
  setLoadingPage,
  setErrorMessage,
  setHeaderVisible,
  setReportAssetId,
  setReportCalendatDate,
  setReportAssetName,
  setReportGroupId,
} from "../../../reducers/actions";
import { connect } from "react-redux";
import TotalSummary from "./totalSummary";
import HourlyTotalSummary from "./hourlyTotalSummary";
import DailySummary from "./dailySummary";
import HourlySummary from "./hourlySummary";
import AssetSummaryMetricTiles from "./metricTiles";
import axios from "axios";
import { apiHost } from "../../../api/apiClient";
import moment from "moment";
import { Button } from "react-bootstrap";
import GridLoader from "react-spinners/GridLoader";
import Calendar from "react-calendar/dist/umd/Calendar";
import ReportButtonGroup from "../../commoncomponents/reportButtonGroup";
import AssetInforWarning from "../../commoncomponents/assetInforWarning";
import TimeZoneConvert from "../../../utils/timeZoneConvert";
import queryString from "query-string";
import Select from "react-select";
import GroupWarning from "../../commoncomponents/groupWarning";

const getAssetSummaryMaxReportDate = () => moment().subtract(1, "day").startOf("day");

const getAssetSummaryDefaultRange = () => {
  const today = moment().startOf("day");

  if (today.date() === 1) {
    const previousMonth = today.clone().subtract(1, "month");
    return {
      start: previousMonth.clone().startOf("month"),
      end: previousMonth.clone().endOf("month").startOf("day"),
    };
  }

  return {
    start: today.clone().startOf("month"),
    end: getAssetSummaryMaxReportDate(),
  };
};

const getValidAssetSummaryDate = (date, fallbackDate) => {
  const maxReportDate = getAssetSummaryMaxReportDate();
  const parsedDate = moment(date);
  const safeDate = parsedDate.isValid() ? parsedDate : fallbackDate.clone();

  return safeDate.isAfter(maxReportDate, "day") ? maxReportDate : safeDate.startOf("day");
};

class AssetRunningSummary extends Component {
  constructor(props) {
    super(props);
    const defaultRange = getAssetSummaryDefaultRange();
    this.state = {
      assetPlaceholder: "Select Asset",
      dataPlaceholder: defaultRange.start.format("dddd Do MMMM, YYYY"),
      calendarSelect: false,
      calendarSelect2: false,
      dataPlaceholder2: defaultRange.end.format("dddd Do MMMM, YYYY"),
      calendarStartDate: defaultRange.start.toDate(),
      calendarEndDate: defaultRange.end.toDate(),
      assetShow: false,
      groupTabHighlight: true,
      assetTabHighlight: false,
      groupTabHeading: true,
      assetTabHeading: true,
      groupCustomerName: "",
      groupGeneralName: "",
      assetCustomerName: "",
      assetGeneralName: "",
      ReportDate: defaultRange.start.format("YYYY-MM-DD"),
      globalDate: defaultRange.start.toDate(),
      endDate: defaultRange.end.format("YYYY-MM-DD"),
      calendarShow: false,
      calendarShow2: false,
      checked: true,
      groupDetails: [],
      groupId: "",
      AssetList: [],
      assetId: "",
      reportDetails: [],
      assetLoader: true,
      reportLoader: false,
      errorLoader: false,
      generatedDate: moment().format("DD-MM-YYYY hh:mm a"),
      assetSelectionBoolean: false,
      isLoading:false,
      summaryMode: "daily",
      hideNoDataDays: false,
      loadedReportParams: null,
    };
    this.groupId = "";
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }
  async componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    const searchDate = values.assetDate || values.SearchDate || values.searchDate;
    const endDate = values.EndDate || values.endDate;
    const assetId = values.assetId || values.AssetId || values.id;
    const assetName = values.assetName || values.AssetName || values.name || "Selected Asset";
    const groupId = values.groupId || values.GroupId;
    const urlState = {};

    if (groupId) {
      this.groupId = groupId;
      urlState.groupId = groupId;
      urlState.assetLoader = true;
      this.props.setReportGroupIdAction(groupId);
      this.getAssets(groupId);
    }

    if (assetId) {
      if (searchDate !== undefined && searchDate !== "null") {
        const validSearchDate = getValidAssetSummaryDate(searchDate, getAssetSummaryDefaultRange().start);
        urlState.dataPlaceholder = validSearchDate.format("dddd Do MMMM, YYYY");
        urlState.ReportDate = validSearchDate.format("YYYY-MM-DD");
        urlState.globalDate = validSearchDate.toDate();
        urlState.calendarStartDate = validSearchDate.toDate();
      }

      if (endDate !== undefined && endDate !== "null") {
        const validEndDate = getValidAssetSummaryDate(endDate, getAssetSummaryDefaultRange().end);
        urlState.dataPlaceholder2 = validEndDate.format("dddd Do MMMM, YYYY");
        urlState.endDate = validEndDate.format("YYYY-MM-DD");
        urlState.calendarEndDate = validEndDate.toDate();
      }

      urlState.assetPlaceholder = assetName;
      urlState.assetCustomerName = assetName;
      urlState.assetId = assetId;
      this.setState(urlState, this.handleCreateReport);
    } else if (Object.keys(urlState).length > 0) {
      this.setState(urlState);
    }

    try {
      let GroupList = await axios.post(
        `${apiHost}/api/Notification/AllGroupForNotification`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      if (GroupList.status === 200) {
        this.setState({ isLoading: false, groupDetails: GroupList.data });
      } else {
        this.setState({ isLoading: true });
      }
    } catch (e) {
      if (e && e.response && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
    }
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ calendarShow: false, calendarShow2: false });
    }
  }

  getAssets = async (groupId) => {
    try {
      let AssetList = await axios.get(
        `${apiHost}/api/Notification/AssetsByGroupId/${groupId || this.groupId}?IsReport=true`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      if (AssetList.status === 200) {
        this.setState({
          isLoading: false,
          AssetList: AssetList.data.paggedlist,
          assetLoader: false,
        });
      } else {
        this.setState({ isLoading: true, assetLoader: false });
      }
    } catch (e) {
      console.warn("Report request failed");
      this.setState({ assetLoader: false });
    }
  };

  handleGroupSelection = (selectedGroup) => {
    if (!selectedGroup) {
      this.groupId = "";
      this.setState({
        groupId: "",
        groupCustomerName: "",
        groupGeneralName: "",
        assetCustomerName: "",
        assetGeneralName: "",
        assetPlaceholder: "Select Asset",
        assetId: "",
        AssetList: [],
        assetLoader: false,
      });
      this.props.setReportGroupIdAction("");
      return;
    }

    const group = selectedGroup.data;
    this.groupId = group.groupId;
    this.setState({
      groupId: group.groupId,
      groupCustomerName: group.customername,
      groupGeneralName: group.groupName,
      assetCustomerName: "",
      assetGeneralName: "",
      assetPlaceholder: "Select Asset",
      assetId: "",
      AssetList: [],
      assetLoader: true,
    });
    this.props.setReportGroupIdAction(group.groupId);
    this.getAssets(group.groupId);
  };

  handleAssetSelection = (selectedAsset) => {
    if (!selectedAsset) {
      this.setState({
        assetId: "",
        assetCustomerName: "",
        assetGeneralName: "",
        assetPlaceholder: "Select Asset",
      });
      return;
    }

    const asset = selectedAsset.data;
    this.setState({
      assetId: asset.assetId,
      assetCustomerName: asset.name,
      assetGeneralName: asset.customerName,
      assetPlaceholder: asset.name,
    });
  };
  toggleGroupTable = () => {
    let assetClosingBoolean = !this.state.groupTabHighlight;
    this.setState({
      groupTabHighlight: !this.state.groupTabHighlight,
    });

    if (assetClosingBoolean) {
      this.setState({
        assetTabHighlight: false,
      });
    }
  };
  toggleAssetTable = () => {
    let groupClosingBoolean = !this.state.assetTabHighlight;

    this.setState({
      assetTabHighlight: !this.state.assetTabHighlight,
    });
    if (groupClosingBoolean) {
      this.setState({
        groupTabHighlight: false,
      });
    }
  };
  truckFunction = () => {
    // alert("truck function clicked");
    this.setState({
      assetShow: !this.state.assetShow,
    });
  };
  calendarFunction = () => {
    this.setState({
      calendarShow: !this.state.calendarShow,
    });
  };
  onChangeDate = (date) => {
    const selectedStartDate = getValidAssetSummaryDate(date, getAssetSummaryDefaultRange().start);
    const currentEndDate = getValidAssetSummaryDate(this.state.endDate, getAssetSummaryDefaultRange().end);
    const selectedEndDate = currentEndDate.isBefore(selectedStartDate, "day") ? selectedStartDate.clone() : currentEndDate;

    this.setState({
      calendarSelect: true,
      calendarStartDate: selectedStartDate.toDate(),
      calendarEndDate: selectedEndDate.toDate(),
      globalDate: selectedStartDate.toDate(),
      ReportDate: selectedStartDate.format("YYYY-MM-DD"),
      endDate: selectedEndDate.format("YYYY-MM-DD"),
      dataPlaceholder: selectedStartDate.format("dddd Do MMMM, YYYY"),
      dataPlaceholder2: selectedEndDate.format("dddd Do MMMM, YYYY"),
      calendarShow: false,
    });
  };
  calendarFunction2 = () => {
    this.setState({
      calendarShow2: !this.state.calendarShow2,
    });
  };
  onChangeDate2 = (date) => {
    const selectedEndDate = getValidAssetSummaryDate(date, getAssetSummaryDefaultRange().end);
    this.setState({
      calendarSelect2: true,
      calendarEndDate: selectedEndDate.toDate(),
      endDate: selectedEndDate.format("YYYY-MM-DD"),
      dataPlaceholder2: selectedEndDate.format("dddd Do MMMM, YYYY"),
      calendarShow2: false,
    });
  };
  handleWindow = () => {
    this.props.setHeaderVisibleAction(!this.props.headerHide);
  };

  getQuickReportUrl = (path, overrides = {}) => {
    const assetName = overrides.assetName || this.state.assetCustomerName || this.state.assetPlaceholder || "";
    const params = new URLSearchParams({
      assetId: overrides.assetId || this.state.assetId,
      assetName,
      SearchDate: overrides.ReportDate || this.state.ReportDate,
      assetDate: overrides.ReportDate || this.state.ReportDate,
      EndDate: overrides.endDate || this.state.endDate,
    });

    const groupId = overrides.groupId || this.state.groupId;
    if (groupId) {
      params.set("groupId", groupId);
    }

    return `${path}?${params.toString()}`;
  };

  openQuickReport = (path) => {
    if (!this.state.assetId) {
      return;
    }

    const href = this.getQuickReportUrl(path);
    const parentWindow = window.opener && !window.opener.closed ? window.opener : window;
    const reportWindow = parentWindow.open(href, "_blank");

    if (reportWindow) {
      reportWindow.focus();
      return;
    }

    window.open(href, "_blank");
  };

  updateCurrentReportUrl = () => {
    const href = this.getQuickReportUrl(this.props.location.pathname);
    this.props.history.replace(href);
  };

  handleSummaryModeChange = (summaryMode) => {
    this.setState({ summaryMode });
  };

  handleHideNoDataDaysChange = () => {
    this.setState((prevState) => ({
      hideNoDataDays: !prevState.hideNoDataDays,
    }));
  };

  handleCreateReport = async () => {
    if (!this.state.assetId) {
      this.setState({
        assetSelectionBoolean: false,
        errorLoader: true,
        reportLoader: false,
      });
      return;
    }

    const reportStartDate = getValidAssetSummaryDate(this.state.ReportDate, getAssetSummaryDefaultRange().start);
    const reportEndDate = getValidAssetSummaryDate(this.state.endDate, getAssetSummaryDefaultRange().end);
    const safeEndDate = reportEndDate.isBefore(reportStartDate, "day") ? reportStartDate.clone() : reportEndDate;
    const reportStartDateValue = reportStartDate.format("YYYY-MM-DD");
    const reportEndDateValue = safeEndDate.format("YYYY-MM-DD");

    this.setState({
      assetSelectionBoolean: true,
      reportLoader: true,
      generatedDate: moment().format("DD-MM-YYYY hh:mm a"),
      calendarStartDate: reportStartDate.toDate(),
      calendarEndDate: safeEndDate.toDate(),
      globalDate: reportStartDate.toDate(),
      ReportDate: reportStartDateValue,
      endDate: reportEndDateValue,
      dataPlaceholder: reportStartDate.format("dddd Do MMMM, YYYY"),
      dataPlaceholder2: safeEndDate.format("dddd Do MMMM, YYYY"),
    });

    this.props.setReportAssetIdAction(this.state.assetId);
    this.props.setReportAssetNameAction(this.state.assetCustomerName || this.state.assetPlaceholder);
    this.props.setReportCalendatDateAction(reportStartDateValue);
    this.props.setReportGroupIdAction(this.state.groupId);
    this.setState({
      loadedReportParams: {
        assetId: this.state.assetId,
        groupId: this.state.groupId,
        reportDate: reportStartDateValue,
        endDate: reportEndDateValue,
      },
    });

    try {
      let ReportDetails = await axios.post(
        `${apiHost}/api/Report/AssetSummary`,
        {
          AssetId: this.state.assetId,
          SearchDate: reportStartDateValue,
          Timezone: localStorage.getItem("timeZoneID"),
          UseFiltering: true,
          EndDate: reportEndDateValue,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      this.props.history.replace(this.getQuickReportUrl(this.props.location.pathname, {
        ReportDate: reportStartDateValue,
        endDate: reportEndDateValue,
      }));
      this.setState({
        reportLoader: false,
        errorLoader: false,
      });

      this.setState({ reportDetails: ReportDetails.data });
    } catch (e) {
      this.setState({ errorLoader: true, reportLoader: false });
      console.warn("Report request failed");
    }
  };

  render() {
    const selectStyles = {
      control: (base, state) => ({
        ...base,
        minHeight: 44,
        backgroundColor: "#f8fafc",
        borderColor: state.isFocused ? "#244b8f" : "#dbe4ef",
        borderRadius: 8,
        boxShadow: state.isFocused ? "0 0 0 2px rgba(36, 75, 143, 0.14)" : "none",
        "&:hover": {
          borderColor: state.isFocused ? "#244b8f" : "#aebdd0",
        },
      }),
      indicatorSeparator: (base) => ({
        ...base,
        backgroundColor: "#dbe4ef",
      }),
      option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected ? "#244b8f" : state.isFocused ? "#edf3fb" : "#fff",
        color: state.isSelected ? "#fff" : "#26354f",
        fontSize: 13,
      }),
      placeholder: (base) => ({
        ...base,
        color: "#7e8da1",
      }),
      singleValue: (base) => ({
        ...base,
        color: "#17233c",
        fontWeight: 700,
      }),
      menu: (base) => ({
        ...base,
        zIndex: 200,
        borderRadius: 8,
        overflow: "hidden",
      }),
    };

    const groupOptions = this.state.groupDetails.map((group) => ({
      value: group.groupId,
      label: `${group.customername} - ${group.groupName}`,
      data: group,
    }));

    const selectedGroupOption =
      groupOptions.find((option) => option.value == this.state.groupId) || null;

    const assetOptions = this.state.AssetList.map((asset) => ({
      value: asset.assetId,
      label: `${asset.name}${asset.customerName ? ` - ${asset.customerName}` : ""}`,
      data: asset,
    }));

    const selectedAssetOption =
      assetOptions.find((option) => option.value == this.state.assetId) ||
      (this.state.assetId
        ? {
            value: this.state.assetId,
            label: this.state.assetPlaceholder,
            data: {
              assetId: this.state.assetId,
              name: this.state.assetPlaceholder,
              customerName: this.state.assetGeneralName,
            },
          }
        : null);
    const loadedReportParams = this.state.loadedReportParams;
    const hasPendingReportChanges = !!(
      loadedReportParams &&
      this.state.assetId &&
      (
        loadedReportParams.assetId !== this.state.assetId ||
        (loadedReportParams.groupId || "") !== (this.state.groupId || "") ||
        loadedReportParams.reportDate !== this.state.ReportDate ||
        loadedReportParams.endDate !== this.state.endDate
      )
    );

    const calendarReport = this.state.calendarShow ? (
      <div
        className="ParentCalender"
        ref={this.setWrapperRef}
        style={{ position: "relative", zIndex: 100 }}
      >
        <div className="CalendarContainer" style={{ position: "absolute" }}>
          <Calendar
            maxDate={getAssetSummaryMaxReportDate().toDate()}
            //  minDate={moment(this.state.globalDate[0]).subtract(3, 'months').toDate()}
            onChange={this.onChangeDate}
            value={this.state.calendarStartDate}
          />
        </div>
      </div>
    ) : (
      ""
    );
    const calendarReport2 = this.state.calendarShow2 ? (
      <div
        className="ParentCalender"
        ref={this.setWrapperRef}
        style={{ position: "relative", zIndex: 100 }}
      >
        <div className="CalendarContainer" style={{ position: "absolute" }}>
          <Calendar
            minDate={this.state.globalDate}
            maxDate={
              moment(this.state.globalDate).add(3, "months").isAfter(getAssetSummaryMaxReportDate())
                ? getAssetSummaryMaxReportDate().toDate()
                : moment(this.state.globalDate).add(3, "months").toDate()
            }
            onChange={this.onChangeDate2}
            value={this.state.calendarEndDate}
          />
        </div>
      </div>
    ) : (
      ""
    );
    return (
      <Layout>
        <Helmet>
          <title>Asset Running Summary</title>
        </Helmet>
        <div className="contentBody">
          <div
            className={
              !this.props.headerHide
                ? `contentWrapper contentWrapperSmoothRelease report-modern-page asset-summary-report-page`
                : `contentWrapper contentWrapperSmooth report-modern-page asset-summary-report-page`
            }
          >
            <div className="reportHeaderTile">
              <div className="headingContainer report-modern-header">
                <div>
                  <h2 className="mainHeading">Asset Summary</h2>
                  <p>Review running totals, daily activity and hourly summaries for a selected asset and date range.</p>
                  <div className="reportFilterNotice">Filtered trip logic is applied to these summary totals.</div>
                </div>
                <i
                  className={
                    this.props.headerHide
                      ? `fa fa-window-restore`
                      : `fa fa-window-maximize`
                  }
                  onClick={this.handleWindow}
                />
              </div>
              <div className="inputFormGroup reportPickerGrid reportPickerToolbar">
                <div className="inputElement reportPickerField">
                  <label>Group</label>
                  <Select
                    value={selectedGroupOption}
                    options={groupOptions}
                    styles={selectStyles}
                    onChange={this.handleGroupSelection}
                    isClearable
                    isSearchable
                    placeholder="Search group"
                    noOptionsMessage={() => "No groups found"}
                  />
                  {this.state.isLoading && (
                    <GroupWarning
                      warningText={true}
                      warningTextHead="No Groups Found"
                      warningTextBody=" You do not have any group memberships. Please contact Support to ensure your account configured correctly."
                    />
                  )}
                </div>
                <div className="inputElement reportPickerField">
                  <label>Asset</label>
                  <Select
                    value={selectedAssetOption}
                    options={assetOptions}
                    styles={selectStyles}
                    onChange={this.handleAssetSelection}
                    isClearable
                    isSearchable
                    isDisabled={!this.state.groupId && !this.state.assetId}
                    isLoading={this.state.assetLoader && this.state.groupId != ""}
                    placeholder={this.state.groupId ? "Search asset" : "Select group first"}
                    noOptionsMessage={() => "No assets found"}
                  />
                </div>
                <div className="inputElement reportPickerField reportPickerDateField">
                  <label>Start Date</label>
                  <ReportButtonGroup
                    function={this.calendarFunction}
                    dropDown={calendarReport}
                    placeholder={this.state.dataPlaceholder}
                    icon="fa-calendar"
                  />
                </div>
                <div className="inputElement reportPickerField reportPickerDateField">
                  <label>End Date</label>
                  <ReportButtonGroup
                    function={this.calendarFunction2}
                    dropDown={calendarReport2}
                    placeholder={this.state.dataPlaceholder2}
                    icon="fa-calendar"
                  />
                </div>
                <div className="inputElement reportPickerActions">
                  <Button
                    className={hasPendingReportChanges ? "reportPickerCreateButton report-create-pending" : "reportPickerCreateButton"}
                    variant="primary"
                    onClick={this.handleCreateReport}
                    size="sm"
                    disabled={this.state.assetId == ""}
                  >
                    <i className="fa fa-bar-chart"></i>
                    Create Report
                  </Button>
                </div>
              </div>
            </div>
            <TimeZoneConvert />
            <div className="reportBody">
              {this.state.reportLoader ? (
                <div className="loaderLine">
                  <br />{" "}
                  <GridLoader
                    size={7}
                    color={"#222222"}
                    loading={this.state.reportLoader}
                  />
                  <h1> &nbsp;Generating Report</h1>
                  <br />
                </div>
              ) : this.state.errorLoader ? (
                <AssetInforWarning warningText={true} warningTextMsg="Something went wrong while generating this report." />
              ) : this.state.assetSelectionBoolean ? (
                <React.Fragment>
                  <div className="assetSummaryModeBar">
                    <button
                      type="button"
                      className={this.state.summaryMode === "daily" ? "active" : ""}
                      onClick={() => this.handleSummaryModeChange("daily")}
                    >
                      Daily Summary
                    </button>
                    <button
                      type="button"
                      className={this.state.summaryMode === "hourly" ? "active" : ""}
                      onClick={() => this.handleSummaryModeChange("hourly")}
                    >
                      Hourly Breakdown
                    </button>
                    {this.state.summaryMode === "daily" && (
                      <label className="assetSummaryNoDataToggle">
                        <input
                          type="checkbox"
                          checked={this.state.hideNoDataDays}
                          onChange={this.handleHideNoDataDaysChange}
                        />
                        Hide days with no data
                      </label>
                    )}
                  </div>

                  {this.state.summaryMode === "daily" ? (
                    <React.Fragment>
                      <AssetSummaryMetricTiles reportDetails={this.state.reportDetails} />
                      <TotalSummary
                        reportDetails={this.state.reportDetails}
                        assetCustomerName={this.state.assetPlaceholder}
                        calendarSelectedDate={this.state.calendarStartDate}
                      />

                      {this.state.reportDetails != "" && (
                        <DailySummary
                          reportDetails={this.state.reportDetails}
                          assetId={this.state.assetId}
                          SearchDate={this.state.ReportDate}
                          EndDate={this.state.endDate}
                          UseFiltering={true}
                          assetCustomerName={this.state.assetPlaceholder}
                          calendarSelectedDate={this.state.calendarStartDate}
                          hideNoDataDays={this.state.hideNoDataDays}
                        />
                      )}
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <AssetSummaryMetricTiles reportDetails={this.state.reportDetails} />
                      <HourlyTotalSummary
                        reportDetails={this.state.reportDetails}
                        assetCustomerName={this.state.assetPlaceholder}
                        calendarSelectedDate={this.state.calendarStartDate}
                      />

                      {this.state.reportDetails != "" && (
                        <HourlySummary
                          reportDetails={this.state.reportDetails}
                          assetId={this.state.assetId}
                          SearchDate={this.state.ReportDate}
                          UseFiltering={true}
                          assetCustomerName={this.state.assetPlaceholder}
                          calendarSelectedDate={this.state.calendarStartDate}
                        />
                      )}
                    </React.Fragment>
                  )}
                </React.Fragment>
              ) : (
                <AssetInforWarning />
              )}
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}
const mapStateToProps = (state) => ({
  loading: state.loading,
  headerHide: state.headerHide,
  timeZoneId: state.timeZoneId,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
  setHeaderVisibleAction: setHeaderVisible,
  setReportAssetNameAction: setReportAssetName,
  setReportAssetIdAction: setReportAssetId,
  setReportCalendatDateAction: setReportCalendatDate,
  setReportGroupIdAction: setReportGroupId,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssetRunningSummary);
